import React from 'react';
import { styled } from 'baseui';
import { TechemTheme } from '@techem/techem-theme';
import { Spinner } from 'baseui/spinner';

var CenteredLoadingSpinner = styled(Spinner, {
  borderTopColor: `${TechemTheme.colors.spinnerTrackFill} !important`
});

const CenteredLoadingIndicator = (props: Omit<any, '$theme'>) => (
  <div className="d-flex w-100 h-100 position-absolute top-0 start-0 bg-transparent">
    <CenteredLoadingSpinner className="m-auto" />
  </div>
);

export default CenteredLoadingIndicator;
